import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import {
  Container,
  Alert,
  Text
} from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import SellerDashboard from '../../components/seller/SellerDashboard';

const SellerDashboardPage = () => {
  const { isAuthenticated, user } = useSelector(state => state.auth);

  // Redirect if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Show message if not a seller
  if (!user?.is_seller) {
    return (
      <Container size="lg" py="xl">
        <Alert 
          icon={<IconExclamationCircle size="1rem" />} 
          color="blue" 
          title="Princess Access Required"
        >
          <Text>
            You need to be a registered princess to access this page. 
            Please register as a princess first to access the princess dashboard.
          </Text>
        </Alert>
      </Container>
    );
  }

  return <SellerDashboard />;
};

export default SellerDashboardPage;